import * as Combobox from '@givebutter/primitives/combobox';
import { PledgeType } from 'constants/pledges';

const PledgeTypeOptions = () => (
    <>
        <Combobox.Item value={PledgeType.Donation}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Donation</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={PledgeType.Sponsorship}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Sponsorship</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={PledgeType.Match}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Match</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={PledgeType.Payroll}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Payroll</Combobox.ItemText>
        </Combobox.Item>
        <Combobox.Item value={PledgeType.Other}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>Other</Combobox.ItemText>
        </Combobox.Item>
    </>
);

export { PledgeTypeOptions };
